import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services'
import { getObject } from '../../utils/useful'
import FormViewer from '../FormViewer'

export default class FieldsInput extends Component {
    state = {
        headers: []
    }
    componentDidMount() {
        this.init()
    }
    componentDidUpdate(prevProps) {

        // console.log(this.props.header.information.filter)
        if (prevProps.header.information.filter?._id != this.props.header.information.filter?._id) {
            // this.setState({ options: this.props.header.information.items })
            this.init()
        }
    }
    init = () => {

        if (this.props.header.information) {
            // if (this.props.header.information.type === "local" || !this.props.header.information.type) {

            //     let options = this.props.header.information.items
            //     let fields = this.props.header.information.fields
            //     if (fields && this.props.header.information.items) {
            //         options = []

            //         this.props.header.information.items.forEach(item => {
            //             options.push({ title: getObject(item, fields.title), value: getObject(item, fields.value) })
            //         });
            //     }

            //     // console.log(options)

            //     this.setState({ options })
            // } else if (this.props.header.information.type === "api") {
            this.fetch()
            // }
        }
    }
    liveChange = (data, init, key, value, extra) => {
        console.log('data', data)
        console.log('key', key)
        console.log('value', value)
        console.log('this.props.header.key', this.props.header.key)
        this.props.changeValue(this.props.header.key, data)
    }
    fetch() {

        // console.log("HERE")
        console.log(this.props.header.information.filter)
        let filter = this.props.header.information.filter
        if (this.props.header.information.sort) {
            filter.sort = this.props.header.information.sort
        }

        console.log(filter)

        for (const [key, value] of Object.entries(filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
                // console.log("VAR")
            }
        }

        if (!filter._id) {
            return
        }
        // console.log(filter)
        // console.log(this.props.variables)
        this.setState({ isLoading: true })
        HttpServices.request(this.props.header.information.address, filter, (fetchResult, fetchError) => {
            if (fetchError) { return }
            console.log(fetchResult)
            console.log('fieldsinput', fetchResult.info)
            let headers = fetchResult.info.fields

            // console.log("NEW DATA")
            // console.log(newData)
            // setTimeout(() => {

            this.setState({
                headers,
                isLoading: false
            })
            // }, 1000);


        })

    }
    render() {
        return (
            <div>
                <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.props.data} liveChange={this.liveChange} formClass="modern" inputClass={'modern-input'} />
            </div>
        )
    }
}
